<template>
  <div class="vl-doc">
    <div class="menuUl leftTree" style="background: #fff">
      <div class="side-title">
        {{ docTitle }}
      </div>
      <el-tree
        ref="tree"
        :current-node-key="currentNodekey"
        :default-expanded-keys="[firstNodeKey]"
        :render-after-expand="false"
        :data="menuList"
        :props="defaultProps"
        :highlight-current="true"
        @node-click="handleNodeClick"
        accordion
        node-key="id"
        @node-expand="nodeExpand"
      >
        <div class="span-ellipsis" slot-scope="{ node, data }">
          <span :title="node.label">{{ node.label }}</span>
        </div>
      </el-tree>
    </div>
    <div
      class="tableCont detailsArticle loading-box"
      v-if="JSON.stringify(docObj) != '{}' && docObj.content"
    >
      <h3 class="artTitle">{{ docObj.title }}</h3>
      <div class="morePaph passage" v-html="docObj.content"></div>
    </div>
    <div class="dataNone loading-box" v-if="hasInit&&JSON.stringify(docObj) === '{}'">
      <img src="../../assets/img/basicDoc/noData.png" alt="" />
      <span>未查询到相关数据</span>
    </div>
  </div>
</template>
<script>
import {
  BasicDocGetBlockTree,
  BasicDocGetDocDetails,
} from "@/views/index/api/basicDoc/api.basicDoc.js";
export default {
  props: ["docInfo"],
  data() {
    return {
      expandDefault: [],
      currentNodekey: "", //默认选中的节点树
      firstNodeKey: '', // 首次进入获取到的key
      defaultProps: {
        children: "children",
        label: "title",
      },
      menuList: [],
      docObj: {},
      docId: null,
      docTitle: "",
      hasInit:false,
    };
  },
  mounted() {
    this.docTitle = this.docInfo.title;
    this.docId = this.docInfo.docId;
    this.getDocData();
  },
  methods: {
    /**
     * 获取文档内容
     * */
    getDocData() {
      let params = {
        docId: this.docId,
      };
      BasicDocGetBlockTree(params).then((res) => {
        if (res && res.result) {
          this.menuList = res.result.children;
          this.getFirstDetails(this.menuList[0]);
        } else {
          this.menuList = [];
          this.docObj = {};
        }
      });
    },
    // 侧边菜单
    handleNodeClick(data) {
      this.getFirstDetails(data);
    },
    nodeExpand() {
      this.$refs["tree"].setCurrentKey(null);
    },
    // 首次进入获取详情
    getFirstDetails(obj) {
      this.hasInit=false;
      this.firstNodeKey = '';
      let params = {
        blockId: obj.id,
      };
      BasicDocGetDocDetails(params).then((res) => {
        if (res && res.result) {
          if (res.result.content) {
            this.docObj = res.result;
            if (!obj.children || !obj.children.length) {
              this.currentNodekey = obj.id;
              this.$nextTick(() => {
                this.$refs.tree.setCurrentKey(this.currentNodekey);
              });
              this.firstNodeKey = obj.id;
            }
             this.hasInit=true;
          } else if (obj.children && obj.children[0]) {
            this.getFirstDetails(obj.children[0])
          }
        } else {
          this.docObj = {};
           this.hasInit=true;
        }
      });
    }
  },
};
</script>
<style lang="scss">
.vl-doc {
  display: flex;
  width: 1200px;
  margin: 0 auto;
  background: #ffffff;
  margin-top: 20px;
  min-height: 857px;
  .side-title {
    width: 250px;
    height: 66px;
    background: #4286f5;
    line-height: 66px;
    font-size: 22px;
    color: #fff;
    text-align: center;
  }
  .leftTree {
    width: 250px;
    background: #fafcfe;
    border: 1px solid #ebeef5;
  }
  .leftTree .span-ellipsis {
    width: 100%;
    height: 100%;
  }
  .leftTree .span-ellipsis span {
    display: block;
    width: 100%;
    height: 100%;
    font-size: 16px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 50px;
  }
  .leftTree .el-tree-node__content {
    height: 55px !important;
  }
  .leftTree .el-tree-node__content:hover {
    background-color: #ecf5fe;
    box-shadow: inset 0 0 1px #c3daf2;
    color: #4286f5;
  }
  .leftTree .is-current .el-tree-node__content {
    color: #4286f5;
    position: relative;
    background-color: #ecf5fe !important;
    box-shadow: inset 0 0 1px #c3daf2;
  }
  .leftTree .is-current .el-tree-node__content::before {
    content: "";
    display: block;
    width: 3px;
    height: 100%;
    background: #4286f5;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
  }
  .leftTree .el-tree-node__children .el-tree-node__content .span-ellipsis span {
    font-size: 14px !important;
  }
  .rightTable {
    width: calc(100% - 330px);
    padding: 20px 40px 20px;
    border: 1px solid #ebeef5;
    border-left: none;
  }
  .menuUl {
    width: 250px;
    border: 1px solid #ebeef5;
  }
  .menuUl > .company {
    background: url(../../assets/img/menuBg.png) no-repeat center;
    background-size: 100% 100%;
    text-align: center;
  }
  .menuUl > .company > img {
    display: inline-block;
    margin: 40px 0 20px 0;
  }
  .menuUl > .company > div {
    text-align: center;
  }
  .menuUl > .company > .name {
    font-size: 18px;
    color: #0059b2;
    font-weight: bold;
  }
  .menuUl > .company > .email {
    font-size: 16px;
    color: #333;
    padding-top: 10px;
    padding-bottom: 15px;
  }
  .menuUl .el-menu {
    border-right: none !important;
  }
  .menuUl .el-menu-item {
    font-size: 18px !important;
    height: 50px !important;
    line-height: 50px !important;
    padding-left: 50px !important;
    transition: background-color 0.3s, color 0.3s !important;
  }
  .menuUl .el-menu-item.is-active,
  .el-menu-item:hover {
    background-color: #f1f8ff !important;
  }
  .menuUl .el-menu-item.is-active {
    border-bottom: 1px solid #ebeef5;
    border-top: 1px solid #ebeef5;
    position: relative;
  }
  .menuUl .el-menu-item.is-active::after {
    content: "";
    position: absolute;
    width: 4px;
    height: 50px;
    background-color: #4286f5;
    left: 0;
    top: -1px;
  }

  .tableCont {
    width: calc(100% - 250px);
    padding: 40px 40px 50px;
    border: 1px solid #ebeef5;
    border-left: none;
  }
  .detailsArticle {
    padding: 40px 70px 100px;
    color: #333;
  }
  .detailsArticle .artTitle {
    font-size: 22px;
    font-weight: bold;
    padding-bottom: 20px;
    position: relative;
    padding-left: 10px;
  }
  .detailsArticle .artTitle::after {
    content: "";
    position: absolute;
    width: 4px;
    height: 25px;
    background-color: #4286f5;
    left: 0;
    top: 3px;
  }
  .detailsArticle .passage h2 {
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 20px;
    padding-top: 20px;
  }
  .detailsArticle .passage h3,
  h4,
  h5,
  h6 {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 20px;
    padding-top: 20px;
  }
  .detailsArticle .passage p {
    font-size: 16px;
    line-height: 30px;
    position: relative;
    margin-bottom: 20px;
  }
  .detailsArticle .passage img {
    max-width: 100%;
    display: inline;
  }
  .detailsArticle .passage table {
    width: 100%;
    margin-bottom: 20px;
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
  }
  .detailsArticle .passage table td,
  .detailsArticle .passage table th {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    padding: 3px 5px;
  }
  .detailsArticle .passage table td p,
  .detailsArticle .passage table th p {
    margin-bottom: 0;
  }
  .detailsArticle .passage b,
  .detailsArticle .passage strong {
    font-weight: bold;
  }
  .detailsArticle .passage i,
  .detailsArticle .passage em {
    font-style: italic;
  }
  .detailsArticle .overstriking {
    padding-bottom: 10px;
    font-weight: bold;
  }
  .dataNone {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: relative;
    border-top: 1px solid #ebeef5;
  }
  .dataNone > img {
    margin-top: -50px;
  }
  .dataNone > span {
    position: absolute;
    color: #333;
    font-size: 16px;
    margin-top: 150px;
  }
}
</style>